import {
	iconContainerStyles,
	iconShadowStyles,
	iconStyles,
	infoContainerStyles,
	rootStyles,
} from '@/components/blocks/HdmNotAvailable/styles/HdmNotAvailableStyle';
import { EMarketingSpot } from '@/components/content/EMarketingSpot';
import { BlockSharp } from '@mui/icons-material';
import { Box, Grid, Paper, SxProps, Theme } from '@mui/material';
import { FC } from 'react';
import './styles/style.css';
import { mergeSx } from '@/utils/mergeSx';

export const HdmNotAvailable: FC<{ emsName: string; sx?: SxProps<Theme> }> = ({ emsName, sx }) => (
	<Paper className="hdm-not-available" sx={mergeSx({ marginTop: '20px' }, sx)}>
		<Grid container sx={rootStyles}>
			<Grid item sx={iconContainerStyles}>
				<Box sx={iconShadowStyles}>
					<BlockSharp sx={iconStyles} />
				</Box>
			</Grid>

			<Grid item sx={infoContainerStyles}>
				<EMarketingSpot id={emsName} properties={{ emsName }} />
			</Grid>
		</Grid>
	</Paper>
);
